import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const validateS3Url = (url) => {
  const parsedUrl = new URL(url);

  // Ensure the URL uses HTTPS
  if (parsedUrl.protocol !== "https:") {
    throw new Error("Insecure URL: HTTPS is required.");
  }

  // Validate the hostname matches the expected S3 bucket and domain
  const expectedHostname = `${process.env.REACT_APP_DATA_UPLOAD_S3_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_PROJECT_REGION}.amazonaws.com`;
  if (parsedUrl.hostname !== expectedHostname) {
    throw new Error(`Invalid URL domain. Expected: ${expectedHostname}`);
  }

  return parsedUrl.href; // Return the validated URL as a string
};

export const getPresignedUrl = async (fileName, fileType, token) => {
  console.log(fileName, fileType);

  const response = await axios.post(
    `${API_BASE_URL}/files/upload/generate`,
    {
      fileName,
      fileType,
    },
    {
      headers: {
        authorizationtoken: token, // Include the token in the headers
      },
    }
  );
  // Check if the response indicates success and contains the presigned URL and key
  if (
    response.data.success &&
    response.data.data.presignedUrl &&
    response.data.data.key &&
    response.data.data.encodedFileName
  ) {
    
    const validatedUrl = validateS3Url(response.data.data.presignedUrl);

    return {
      presignedUrl: validatedUrl,
      key: response.data.data.key,
      encodedFileName: response.data.data.encodedFileName, // Include encodedFileName
    };
  } else {
    throw new Error(response.data.message || "Failed to generate presigned URL.");
  }
};

export const uploadFileToS3 = async (uploadUrl, file, onProgress, metadata = {}, retries = 3) => {
  
  const validatedUrl = validateS3Url(uploadUrl);
  
  const headers = {
    "Content-Type": file.type, // Ensure this matches the MIME type
    ...Object.fromEntries(
      Object.entries(metadata).map(([key, value]) => [`x-amz-meta-${key}`, value])
    ),
  };

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      console.log(`Attempt ${attempt} to upload file: ${file.name}`);
      await axios.put(validatedUrl, file, {
        headers,
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            if (onProgress) {
              onProgress(progress);
            }
          }
        },
      });
      console.log("File uploaded successfully.");
      return; // Exit the function if the upload succeeds
    } catch (error) {
      console.error(`Upload attempt ${attempt} failed:`, error.message || error);
      if (attempt === retries) {
        throw new Error(`Failed to upload file after ${retries} attempts.`);
      }
    }
  }
};

export const fetchUploadHistory = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/files/history`, {
      headers: {
        authorizationtoken: token,
      },
    });

    if (response.status !== 200 || !response.data.success) {
      throw new Error(response.data.message || "Failed to fetch upload history");
    }

    // Parse the response body and map the data
    const uploadHistory = response.data.data.map((file) => ({
      fileName: file.key.split("/").pop(), // Extract the file name from the key
      originalFileName: decodeURIComponent(file.metadata.originalfilename), // Decode the original filename
      uploadDate: file.lastModified, // Use the lastModified field
      size: file.size, // Include the file size
    }));

    return uploadHistory;
  } catch (error) {
    console.error("Error fetching upload history:", error);
    throw error;
  }
};

// export const fetchAvailableFiles = async (token) => {
//   try {
//     const response = await axios.get(`${API_BASE_URL}/files/available`, {
//       headers: {
//         authorizationToken: token,
//       },
//     });
//     if (response.status !== 200) {
//       throw new Error("Failed to fetch available files");
//     }
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching available files:", error);
//     throw error;
//   }
// };